import { useEffect, useState } from "react";
import { Button, Container, Row, Col } from "react-bootstrap";
import API from "../api/api";
import AccountInfo from "../components/settings/AccountInfo";
import Subscription from "../components/settings/Subscription";
export default function Settings(props) {

    useEffect(() => {
        document.title = 'ScamWall | Settings'

    }, [])

    return (
        <Container className='p-4 text-start mt-3'>
            <AccountInfo />
            <hr />

            {/*<Subscription />*/}

        </Container>
    )
}